module.exports = __webpack_public_path__ + "img/iconeProdutos.7d5e2575.png";